import { render } from "./PdfFileComponent.vue?vue&type=template&id=bfbf88f2"
import script from "./PdfFileComponent.vue?vue&type=script&lang=js"
export * from "./PdfFileComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__